import Seo, { faqLd, breadcrumbLd } from "@/components/Seo";
import { MarketingNav, MarketingFooter, MarketingCTA } from "@/components/MarketingChrome";
import { FAQ, CATEGORIES } from "@/pages/FAQ";

const ALL = CATEGORIES.flatMap((c) => c.items);

export default function FaqPage() {
  return (
    <div className="min-h-screen bg-sand-50 text-ink" data-testid="faq-page">
      <Seo
        title="FAQ, Ask Redline for HOAs & Community Management Companies"
        description="Answers about the Ask Redline text & voice resident concierge, live support, security monitoring, setup, data, privacy & TCPA compliance, plans and rollout."
        canonical="/faq"
        jsonLd={[faqLd(ALL), breadcrumbLd([{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq" }])]}
      />
      <MarketingNav />
      <header className="max-w-4xl mx-auto px-6 pt-16 sm:pt-20 pb-0" data-testid="faq-page-header">
        <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">Frequently asked questions</h1>
      </header>
      <FAQ />
      <MarketingCTA />
      <MarketingFooter />
    </div>
  );
}
